<div class="bn-alert-notice bn-imp-notice manage-ap-imp-notice mb-4 mt-4" *ngIf="!hideAlert">
    <div class="bn-icon">
        <img src="./assets/img/images/icon-warning-32.svg" alt="warning icon" />
    </div>
    <div class="bn-content">
        <div class="bn-content-text">
            <div class="imp-notice-sec">
                <div class="imp-notice-info-block mr-3">
                    <div class="imp-notice-title">Important notice</div>
                     <div class="manage-ap-imp-info">Before enrolling, please note that we can’t accept 
                        <span class="fw-700">Cash App or Chime</span>  for payments (ACH/EFT). If you’re paying from a 
                        <span class="fw-700">credit union, use your routing and account number</span>—not your member ID.
                    </div>
                </div>
                <div class="imp-content-close">
                    <img src="./assets/img/images/icon-close-18.svg" class="cursor-pointer" alt="close icon"
                        (click)="onClose()" />
                </div>
            </div>
        </div>
    </div>
</div>